var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-checkbox",
      class: { "nsc-enabled": _vm.enabled, "nsc-disabled": !_vm.enabled },
      style: { display: _vm.inline ? "inline-block" : "" }
    },
    [
      _c(
        "label",
        {
          staticClass: "nsc-container",
          style: { "line-height": _vm.size + "px" }
        },
        [
          _c(
            "span",
            {
              staticClass: "nsc-input",
              style: { width: _vm.size + "px", height: _vm.size + "px" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                attrs: { type: "checkbox", disabled: !_vm.enabled },
                domProps: {
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, null) > -1
                    : _vm.model
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.model,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.model = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.model = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.model = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "nsc-icon" },
                [
                  _c("NsIcon", {
                    staticClass: "nsc-icon-check",
                    attrs: { "icon-name": _vm.iconName, color: "#FFFFFF" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "nsc-label" },
            [
              _vm._t("label", [
                _vm._v("\n        " + _vm._s(_vm.label) + "\n      ")
              ])
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.$slots["additional"] || _vm.$scopedSlots["additional"]
        ? _c(
            "div",
            {
              staticClass: "nsc-additional",
              style: { "margin-left": _vm.size + "px" }
            },
            [_vm._t("additional")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }